import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import apiInstance from "../apiInstance";
import { changeCurrentUser } from "../../state/actionCreators";

export default function Confirm() {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.currentUser);
    const [params] = useSearchParams();
    const websiteId = params.get("wid");
    const sessionId = params.get("sessionId");

    const [status, setStatus] = useState("processing");
    const [error, setError] = useState("");

    useEffect(() => {
        let attempts = 0;

        const interval = setInterval(async () => {
            attempts++;

            if (attempts > 50) {
                setStatus("failed");
                clearInterval(interval);
                return;
            }

            try {
                const response = await apiInstance.get(`/dashboard/confirm-purchase/${websiteId}?session_id=${sessionId}`);
                const { status: backendStatus, website, user: fetchedUser } = response.data;

                if (website?.status === "claimed") {
                    if (!user?.email && backendStatus === "autologin" && fetchedUser) {
                        localStorage.setItem("token", fetchedUser.token);
                        localStorage.setItem("userId", fetchedUser.id);
                        dispatch(changeCurrentUser(fetchedUser));
                    }

                    setStatus("completed");
                    clearInterval(interval);
                }

            } catch (err) {
                console.error(err);
                setError("Failed to confirm purchase. Please try again later.");
                setStatus("failed");
                clearInterval(interval);
            }
        }, 5000);

        return () => clearInterval(interval);
    }, [websiteId, sessionId, dispatch, user]);

    return (
        <div className="mjs-body">
            <div className="confirmation-container">
                {status === "processing" && (
                    <>
                        <h2>Thank You!</h2>
                        <p>Your order is being processed…</p>
                        <p>This may take 2-5 seconds.</p>
                    </>
                )}
                {status === "completed" && (
                    <>
                        <h2>Payment Successful!</h2>
                        <button 
                            className="mjs-btn"
                            onClick={() => window.location.href = "/dashboard"}
                        >
                            Go to Dashboard
                        </button>
                    </>
                )}
                {status === "failed" && (
                    <>
                        <h2>Something went wrong!</h2>
                        <p>We couldn't verify your payment. Please try again or contact support.</p>
                        <button 
                            className="mjs-btn"
                            onClick={() => window.location.href = "/dashboard"}
                        >
                            Go to Dashboard
                        </button>
                    </>
                )}
                
            </div>
        </div>
    );
}
